"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFormatMoney = void 0;
const numberRound_1 = require("./numberRound");
const precisions = ['', '.0', '.00', '.000', '.0000', '.00000', '.000000', '.0000000', '.00000000'];
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function numberFormatMoney(value, forcezeros, precision = 2) {
    if (value === null) {
        return '';
    }
    if (value % 1 === 0) {
        if (forcezeros) {
            return value.toString() + precisions[precision].replace('.', ',');
        }
        else {
            return value.toString();
        }
    }
    const s = (0, numberRound_1.numberRound)(value, precision).toFixed(precision);
    if (forcezeros) {
        return s.replace('.', ',');
    }
    else {
        return s.replace(precisions[precision], '').replace('.', ',');
    }
}
exports.numberFormatMoney = numberFormatMoney;
//# sourceMappingURL=numberFormatMoney.js.map